var _circle, _rect, _path, _rect2, _rect3, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClassClose(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#70747D"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10.8337,
    y: 11.7502,
    width: 18.3333,
    height: 16.5,
    rx: 1.83333,
    stroke: "white",
    strokeWidth: 1.83333
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8335 14.5H29.1668V27.3333H10.8335V14.5Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 14.5005,
    y: 9,
    width: 1.83333,
    height: 4.58333,
    rx: 0.916667,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 23.667,
    y: 9,
    width: 1.83333,
    height: 4.58333,
    rx: 0.916667,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5094 19.048C18.9411 18.8256 19.431 18.7 19.9501 18.7C21.6898 18.7 23.1001 20.1103 23.1001 21.85C23.1001 22.3691 22.9745 22.859 22.7521 23.2907L18.5094 19.048ZM17.2628 20.2056C16.9693 20.6843 16.8001 21.2474 16.8001 21.85C16.8001 23.5897 18.2104 25 19.9501 25C20.5527 25 21.1158 24.8308 21.5945 24.5373L17.2628 20.2056ZM19.9501 17C17.2715 17 15.1001 19.1714 15.1001 21.85C15.1001 24.5286 17.2715 26.7 19.9501 26.7C22.6287 26.7 24.8001 24.5286 24.8001 21.85C24.8001 19.1714 22.6287 17 19.9501 17Z",
    fill: "#70747D"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClassClose);
export default __webpack_public_path__ + "static/media/class_close.132ced49257880fa15f56b7f69b2e69e.svg";
export { ForwardRef as ReactComponent };